// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__kSlBL"};